import React from "react";
import "./JoinUsTable.css"
const JoinUsTable = ({ data,page,limit, }) => {
  return (
    <div className="quote-table-wrapper">
      <table className="quote-table ">
        <thead>
          <tr>
            <th>Sr No.</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>City</th>
            <th>Gender</th>
            <th>Employment</th>
            <th>Experience</th>
            <th>Expertise</th>
            <th>Services</th>
            <th>Travel</th>
            <th>GST</th>
            <th>KYC</th>
            <th>Portfolio</th>
          </tr>
        </thead>

        <tbody>
          {data?.length > 0 ? (
            data.map((item,index) => (
              <tr key={item._id}>
                 {/* Sr */}
                <td className="td-sr">{(page - 1) * limit + index + 1}</td>
                <td>{item.fullName}</td>
                <td>{item.phoneNumber}</td>
                <td>{item.emailId}</td>
                <td>{item.city}</td>
                <td>{item.gender}</td>
                <td>{item.employmentType}</td>
                <td>{item.experience}</td>

                {/* Array fields */}
                <td>{item.professionalExpertise?.join(", ")}</td>
                <td>{item.primaryServicesOffered?.join(", ")}</td>

                <td>{item.willingToTravel}</td>
                <td>{item.gstRegistration}</td>
                <td>{item.kycAvailable}</td>

                {/* Portfolio Link */}
                <td className="portfolio-link">
                  {item.portfolioLinks ? (
                    <a
                      href={item.portfolioLinks}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="portfolio-link"
                    >
                      {item.portfolioLinks}
                    </a>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="13" style={{ textAlign: "center" }}>
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default JoinUsTable;